import React, {Component} from 'react'
import ReactDOM from 'react-dom'

import style from "./style.module.css";
import {colors} from "../../configs";

const DEFAULT_PLACEHOLDER_STRING = 'Select one Scenario';

export class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
    this.mounted = true;
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleDocumentClick, false)
    document.addEventListener('touchend', this.handleDocumentClick, false)
  }

  componentWillUnmount() {
    this.mounted = false;
    document.removeEventListener('click', this.handleDocumentClick, false)
    document.removeEventListener('touchend', this.handleDocumentClick, false)
  }

  handleMouseDown(event) {
    if (this.props.onFocus && typeof this.props.onFocus === 'function') {
      this.props.onFocus(this.state.isOpen)
    }
    if (event.type === 'mousedown' && event.button !== 0) return
    event.stopPropagation();
    event.preventDefault();

    this.props.onIndicatorClick();

    if (!this.props.disabled) {
      this.setState({
        isOpen: !this.state.isOpen,
      })
    }
  }

  setValue(option) {
    this.props.onChange(option);
    this.setState( {
      isOpen: false
    })
  }

  renderOption(option,i) {
    return (
        <span
            key={i}
            className={`${i === this.state.selected ? "isSelected" : ""} ${style.menuListItem}`}
            onMouseDown={this.setValue.bind(this, option)}
            onClick={this.setValue.bind(this, option)}
        >
          {option.label}<br/><br/>
        </span>
    )
  }

  handleDocumentClick(event) {
    if (this.mounted) {
      if (!ReactDOM.findDOMNode(this).contains(event.target)) {
        if (this.state.isOpen) {
          this.setState({isOpen: false})
        }
      }
    }
  }

  render() {
    const {options, selectedCode, css = {}, showIndicator=true, onIndicatorClick} = this.props;

    const disabledClass = this.props.disabled ? style.disabled : '';
    const isOpenClass = this.state.isOpen ? style.isOpen : "";
    const selectedOption = options.find(op => op.key === selectedCode);
    const placeHolderValue = selectedOption !== null? selectedOption.label : DEFAULT_PLACEHOLDER_STRING;

    return (
        <div
            className={`${style.dropdown} ${isOpenClass} ${disabledClass}`}
            style={css}
        >
          {
            showIndicator &&
            <div className={style.ripple}
                 style={{
                   position: "absolute",
                   top: "0",
                   left: "105px",
                   zIndex: 99999999,
                   cursor: "pointer"
                 }}
                 onMouseDown={()=>{
                   this.setState({
                     isOpen: true
                   });
                   onIndicatorClick()
                 }}
            >
              <img src={"/icons/ripple.svg"}/>
            </div>
          }

          <div className={style.control}
               onMouseDown={this.handleMouseDown.bind(this)}
               onTouchEnd={this.handleMouseDown.bind(this)}
          >
            <div className={style.placeholder}>{placeHolderValue}</div>
            <span className={style.arrow}>
              <img src={"./arrow-down.png"}/>
            </span>
          </div>

          {
            this.state.isOpen &&
            <div className={`${style.menu}`}
                 style={css}
            >
              <div className={style.menuInnerWrapper}>
                <div className={style.menuBorder}
                     style={css}
                />
                <div className={style.menuList}>
                  {
                    options
                        .filter((option, i) => option.key !== selectedCode)
                        .map((option, i)=> this.renderOption(option, i))
                  }
                </div>
              </div>
            </div>
          }
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdown/index.js